import React from "react";
import UserList from "../../components/user/UserList";

const UsersPage = () => {
    return <UserList/>
}

export default UsersPage;